import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// element ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 引入全局 Loading 插件
import "@/plugins/loading"; 
import dayjs from 'dayjs'

// 初始化 css
import "@/assets/css/auto.scss";
import "@/assets/css/elementUi.scss";
import "@/assets/css/element-#061B30/index.css";
import "@/assets/css/rem.css";
// 图标
import "@/assets/font/iconfont.css";
import "@/assets/css/index.css";
// rem 自适应
import { htmlAuto } from "@/utils/rem";
window.addEventListener("resize", htmlAuto);

Vue.config.productionTip = false;
Vue.prototype.$dayjs = dayjs;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
